export default __webpack_public_path__ + "static/media/42.df085881.png";